import React from "react";
import { Button } from "devextreme-react";
import styles from "../../../styles/stylesgenerales";

class Step5 extends React.PureComponent {
  render() {
    const { nextStep, disabled } = this.props;
    return (
      <div className="acceso row" style={{ justifyContent: "center" }}>
        <div className="tituloLogin col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <h2
            className="titulo-validacion-cuenta"
            style={{ textAlign: "center", paddingTop: 5, marginBottom: "10px" }}
          >
            {`Restablecimiento de contraseña`}
          </h2>
          <p
            className="texto-subtitulo"
            style={{
              marginTop: "40px",
              marginBottom: "40px",
              fontSize: '1em'
            }}
          >{` ¡Felicidades! Ya puedes acceder a ACHS Virtual con tu usuario (rut o correo) y nueva contraseña`}</p>
        </div>

        <div
          className="componentesLogin col-xs-12 col-sm-12 col-md-12 col-lg-12"
          style={{ textAlign: "center" }}
        >
          <Button
            style={styles.fullWidth}
            text="Ingresar a ACHS Virtual"
            type="default"
            disabled={disabled}
            onClick={nextStep}
          />
        </div>
      </div>
    );
  }
}

export default Step5;
